module.exports = __webpack_public_path__ + "img/IN.4d124dad.svg";